import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { formatErr, http } from "../lib/api";
import { LogoMark } from "../components/site/Logo";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await http.post("/auth/login", { email, password });
      nav("/admin");
    } catch (err) {
      setError(formatErr(err));
    } finally {
      setBusy(false);
    }
  };

  const input = "h-12 w-full border border-white/10 bg-[#121820] px-4 outline-none focus:border-[#E11D48]";
  return (
    <main data-testid="admin-login-page" className="flex min-h-screen items-center justify-center px-4">
      <form onSubmit={submit} className="w-full max-w-sm space-y-4">
        <LogoMark className="h-12 w-12" />
        <h1 className="font-display text-5xl font-black uppercase">Admin</h1>
        <input data-testid="admin-email-input" type="email" required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className={input} />
        <input data-testid="admin-password-input" type="password" required placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className={input} />
        {error && <p data-testid="admin-login-error" className="text-sm text-[#F43F5E]">{error}</p>}
        <button data-testid="admin-login-button" disabled={busy} className="flex h-12 w-full items-center justify-center gap-2 rounded-full bg-[#E11D48] font-semibold hover:bg-[#F43F5E] disabled:opacity-60">
          {busy && <Loader2 className="h-4 w-4 animate-spin" />} Sign in
        </button>
      </form>
    </main>
  );
}
